import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useRequestMagicLinkMutation } from '../../features/auth/authApi';
import { useResendCooldown } from '../../lib/useResendCooldown';
import Button from '../../components/ui/Button';

/** Confirmation screen after POST /auth/magic-link — the actual sign-in happens when the emailed link is opened (see MagicLinkConsume). */
export default function MagicLinkSent() {
  const location = useLocation();
  const email = location.state?.email;
  const [requestMagicLink, { isLoading }] = useRequestMagicLinkMutation();
  const { remaining, start, canResend } = useResendCooldown(60);
  const [sentAgain, setSentAgain] = useState(false);

  if (!email) {
    return (
      <div className="text-center">
        <p className="text-sm text-foreground-muted mb-4">
          We couldn't find a magic-link request in progress.
        </p>
        <Link to="/login"><Button className="w-full">Back to login</Button></Link>
      </div>
    );
  }

  const onResend = async () => {
    await requestMagicLink({ email }).unwrap().catch(() => null);
    setSentAgain(true);
    start();
  };

  return (
    <div className="text-center">
      <p className="text-4xl mb-3">📩</p>
      <h1 className="text-xl font-semibold text-foreground mb-2">Check your email</h1>
      <p className="text-sm text-foreground-muted mb-6">
        If <span className="text-foreground">{email}</span> is a registered investor account, we've sent a
        one-time sign-in link. Open it on this device to finish signing in — the link expires shortly and
        can only be used once.
      </p>

      {sentAgain && <p className="text-xs text-accent mb-4">Sent again — check your inbox.</p>}

      <p className="text-sm text-foreground-muted">
        Didn't get it?{' '}
        <button
          type="button"
          onClick={onResend}
          disabled={!canResend || isLoading}
          className="text-accent hover:underline disabled:text-foreground-subtle disabled:no-underline disabled:cursor-not-allowed"
        >
          {canResend ? 'Send again' : `Resend in ${remaining}s`}
        </button>
      </p>

      <p className="text-sm text-foreground-muted mt-4">
        <Link to="/login" className="text-accent hover:underline">Back to login</Link>
      </p>
    </div>
  );
}
